/** @format */

import { useLanguageContext } from "../context/LanguageContext";
import Footer from "../components/sections/Footer"
import LanguageSelector from "../components/LanguajeSelector";
export default function NotFound() {
  const { t } = useLanguageContext();
  return (
    <main className="brokenbg flex flex-col h-dvh w-full items-center justify-center gap-20 text-white text-center gap-8">
      <div>
        <h1 className="text-8xl font-semibold">404</h1>
        <h2 className="text-3xl py-3">{t("errorPage", "general", "title")}</h2>
        <p>{t("errorPage", "general", "subtitle")}</p>
      </div>
      <div>
        <p>{t("errorPage", "general", "subtitle2")}</p>
        <div className="p-10">
          <a className="text-center py-3 px-5 bg-main_accent rounded-lg cursor-pointer hover:bg-main_accent_hover mx-2" href="/">
            {t("errorPage", "general", "buttonMap")}
          </a>
          <a className="text-center py-3 px-5 bg-main_accent rounded-lg cursor-pointer hover:bg-main_accent_hover mx-2" href="/about">
            {t("errorPage", "general", "buttonMoreInfo")}
          </a>
        </div>
      </div>
      <LanguageSelector/>
      <Footer/>
    </main>
  );
}
